import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [{
    // path: '/',
    // components: Layout,
    // redirect: '/index',
    // children:
    //   [{
    path: '/',
    redirect: '/index',
  }, {
    path: '/index',
    name: 'Index',
    meta: {
      title: '券卡查询',
    },
    component: () => import('@/views/index')
  }, {
    path: '/applySend',
    name: 'ApplySend',
    meta: {
      title: '申请发货',
    },
    component: () => import('@/views/applySend')
  }, {
    path: '/perfectInfo',
    name: 'PerfectInfo',
    meta: {
      title: '完善收货信息',
    },
    component: () => import('@/views/perfectInfo')
  }, {
    path: '/applySuccess',
    name: 'ApplySuccess',
    meta: {
      title: '申请成功',
    },
    component: () => import('@/views/applySuccess')
  }, {
    path: '/orderDetails',
    name: 'OrderDetails',
    meta: {
      title: '订单详情',
    },
    component: () => import('@/views/orderDetails')
  }, {
    path: '/checkResult',
    name: 'CheckResult',
    meta: {
      title: '查询结果',
    },
    component: () => import('@/views/checkResult')
  }, {
    path: '/sendGood',
    name: 'SendGood',
    meta: {
      title: '商家发货',
    },
    component: () => import('@/views/sendGood')
  }, {
    path: '/goodList',
    name: 'GoodList',
    meta: {
      title: '商品列表',
    },
    component: () => import('@/views/goodList')
  }, {
    path: '/test',
    name: "Test",
    meta: {
      title: '测试'
    },
    component: () => import('@/views/Test')
  }],
  //每次进入页面时都初始化滚轴位置
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
  // }]
})



// WEBPACK FOOTER //
// ./src/router/index.js